function initFAQ() {
  const accordions = document.querySelectorAll('.pagefx-accordion');
  if (!accordions.length) return;

  function collapseAllAccordions() {
    accordions.forEach((accordion) => {
      const triggerElement = accordion.querySelector('.pagefx-accordion__trigger');
      const targetElement = accordion.querySelector('.pagefx-accordion__target');
      collapseAccordion(triggerElement, targetElement);
    });
  }

  function collapseAccordion(triggerElement, targetElement) {
    triggerElement.classList.remove('active');
    targetElement.classList.remove('active');
    triggerElement.setAttribute('aria-expanded', false);
  }

  function expandAccordion(triggerElement, targetElement) {
    collapseAllAccordions();
    triggerElement.classList.add('active');
    targetElement.classList.add('active');
    triggerElement.setAttribute('aria-expanded', true);
  }

  function toggleAccordion(trigger, target) {
    if (trigger.classList.contains('active')) {
      collapseAccordion(trigger, target);
    } else {
      expandAccordion(trigger, target);
    }
  }

  function initializeAccordion(element, index) {
    const triggerElement = element.querySelector('.pagefx-accordion__trigger');
    const targetElement = element.querySelector('.pagefx-accordion__target');

    if (!triggerElement || !targetElement) {
      throw new Error('Accordion element must contain a trigger and target element to expand/contract');
    }

    targetElement.id = targetElement.id || `pagefx_accordion_section_${index}`;
    triggerElement.id = triggerElement.id || `pagefx_accordion_trigger_${index}`;

    if (!triggerElement.getAttribute('aria-controls')) {
      triggerElement.setAttribute('aria-controls', targetElement.id);
    }

    if (!triggerElement.getAttribute('aria-expanded')) {
      triggerElement.setAttribute('aria-expanded', 'false');
    }

    if (!targetElement.getAttribute('aria-labelledby')) {
      targetElement.setAttribute('aria-labelledby', triggerElement.id);
    }

    triggerElement.addEventListener('click', () => {
      toggleAccordion(triggerElement, targetElement);
    });
  }

  accordions.forEach((accordion, index) => {
    initializeAccordion(accordion, index);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initFAQ();
}, false);
